import Flag from './Flag';
import './CountryLabel.scss';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SellerRoutesEnum } from '../../core/enums';

interface Props {
  country: string;
  className?: string;
  badgeText?: string;
  link?: boolean;
}

const CountryLabel = ({
  country,
  className = '',
  badgeText,
  link = false,
  ...rest
}: Props) => {
  const { t } = useTranslation();

  const content = (
    <div
      className={`CountryLabel d-flex align-items-center ${className}`}
      {...rest}
    >
      <div className='flex-shrink-0 d-flex align-items-center'>
        <Flag country={country} className='me-2' />
      </div>
      <div className='d-flex align-items-center text-truncate'>
        <span className='text-truncate'>
          {country === 'EU' ? 'OSS' : t(country)}
        </span>
        {badgeText && <span className='CountryLabel__badge'>{badgeText}</span>}
      </div>
    </div>
  );

  if (country !== 'EU' && link) {
    return (
      <Link
        to={{
          pathname: SellerRoutesEnum.CountryDetails.replace(':id', country),
          state: { hasPrevPath: true },
        }}
        className='col d-flex align-items-center'
      >
        {content}
      </Link>
    );
  }

  return content;
};

export default CountryLabel;
